<template>
    <div class="hidden sm:block">
        <font-awesome-icon icon="bars" class="w-5 text-xl font-black m-2" @click="navTools.toggleMobileNav"/>
        <div class="fixed inset-0 z-50 sm:border-r-0 border-r-gray-300 h-screen w-screen transition-all bg-white text-black ease-in-out duration-300 transform overflow-x-hidden overflow-y-scroll" :class="classes">
            <div class="flex justify-end mr-3 mt-2">
                <FontAwesomeIcon icon="times" size="lg" @click="navTools.toggleMobileNav"/>
            </div>      
            <div class="m-5 text-sm">
                <h2 class="text-lg mb-1 mt-4  font-bold" :class="getcolor">GA NAAR ... </h2>
                <div class="xs:flex">
                    <QuickLinks class="w-full mb-5 xs:w-1/2">
                        <QuickLink class="w-1/5" to="/contact">contact</QuickLink>
                        <QuickLink class="w-1/5" to="https://moodle.cvovolt.be" target="_blank">leerplatform</QuickLink>
                        <QuickLink class="w-1/5" to="/lokaal">lokaal</QuickLink>
                    </QuickLinks>
                    <QuickLinks class="w-full mb-10 xs:w-1/2 xs:mb-5">
                        <QuickLink class="w-1/5" :to="pathTools.waaromCvoVoltLink()">waarom cvo volt</QuickLink>
                        <QuickLink class="w-1/5" :to="pathTools.faqLink()">FAQ</QuickLink>
                        <QuickLink class="w-1/5" to="/nieuws/infomomenten">infomomenten</QuickLink>
                        <QuickLink class="w-1/5" to="https://mijn.cvovolt.be" target="_blank">mijn cvo volt</QuickLink>
                        <QuickLink class="w-1/5" to="https://enlito.be/" target="_blank">B2B Enlito</QuickLink>
                    </QuickLinks>          
                </div>              
                <NavbarAanbodMegaMenu class="bg-white left-0 text-grey-dark pb-4 -ml-6" />
            </div>      
        </div>
    </div>
</template>

<script setup>
    const pathTools = usePathTools();
    const navTools = useNavTools();

    const classes = computed(() => navTools.mobileNavShow.value ? 'translate-x-0 border-r ' : '-translate-x-full')
    const getcolor = computed(() => `text-${pathTools.colorAccent}`)
</script>
